<mat-toolbar color="primary" id="toolbar">

  <span>
    <span class="mat-display-3"> VIC </span> <span class="mat-display-1"> Vehicle Identity Card</span>
  </span>

  <img src="assets/loghi/logoSystemDataWhite.png" height="50">

</mat-toolbar>
